'use client'

import { useCallback, useState } from 'react'

/**
 * Hook for managing boolean state with toggle functionality
 * Provides convenient methods for setting, toggling, and resetting boolean values
 */
export function useToggle(initialValue = false) {
  const [value, setValue] = useState(initialValue)

  const toggle = useCallback(() => {
    setValue((prev) => !prev)
  }, [])

  const setTrue = useCallback(() => {
    setValue(true)
  }, [])

  const setFalse = useCallback(() => {
    setValue(false)
  }, [])

  const reset = useCallback(() => {
    setValue(initialValue)
  }, [initialValue])

  return {
    value,
    toggle,
    setTrue,
    setFalse,
    reset,
    setValue,
  }
}
